import { render } from "./UploadFileButton.vue?vue&type=template&id=25a4db50&scoped=true&lang=pug"
import script from "./UploadFileButton.vue?vue&type=script&lang=js"
export * from "./UploadFileButton.vue?vue&type=script&lang=js"

import "./UploadFileButton.vue?vue&type=style&index=0&id=25a4db50&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a4db50"]])

export default __exports__